export const passKey = "passname";



export const semana = [
    "Semana",
    "Domingo/Feriado"
]

export const unidadMedida = [
    "Unitario",
    "Kilometros",
    "Metros"
]

export const tipoRemito = [
    "DEVOLUCION",
    "ENTREGA",
    "TRASPASO"
]

export const tipoDeco = [
    "ont",
    "flow",
    "ext"
]

export const tipoOt = [
    "Instalacion",
    "Soporte",
    "Mudanza externa",
    "Solo Visita",
    "No Factible"
]

export const ciudades = [
    "ALTOS",
    "AREGUA",
    "ASUNCION",
    "BENJAMIN ACEVAL",
    "CAPIATA",
    "FERNANDO DE LA MORA",
    "GUARAMBARE",
    "ITA",
    "ITAUGUA",
    "J. AUGUSTO SALDIVAR",
    "LAMBARE",
    "LIMPIO",
    "LUQUE",
    "MARIANO ROQUE ALONSO",
    "NUEVA ITALIA",
    "ÑEMBY",
    "SAN ANTONIO",
    "SAN BERNARDINO",
    "SAN LORENZO",
    "VILLA ELISA",
    "VILLA HAYES",
    "VILLETA",
    "YPACARI",
    "YPANE",
    "OTRO"
];

export const departamentos = [
    "ALTO PARAGUAY",
    "BOQUERÓN",
    "PRESIDENTE HAYES",
    "CONCEPCIÓN",
    "AMAMBAY",
    "SAN PEDRO",
    "CANINDEYÚ",
    "CORDILLERA",
    "CAAGUAZÚ",
    "ALTO PARANÁ",
    "CENTRAL",
    "PARAGUARÍ",
    "GUAIRÁ",
    "ÑEEMBUCÚ",
    "MISIONES",
    "CAAZAPÁ",
    "ITAPÚA",
]

export const idCuadrillaBodega = 0;
export const idCuadrillaNucleo = 1;
export const filesPage = 100;

export const headingsTable = [[
    "Item",
    "Nro Formulario",
    "Departamento",
    "Work Order",
    "Nro Cita",
    "CONTRATO",
    "OT",
    "Cliente",
    "CIUDAD",
    "Dia",
    "Mes",
    "Año",
    "Fecha Asistida",
    "Dia",
    "Tipo OT",
    "Descarga Field Manager",
    "Instalación Básica 1P (Solo FTTX)",
    "Instalación Sólo Flow",
    "Instalación Básica 2P (FTTX + FLOW)",
    "Media Jornada de trabajo - FTTH/Wireless",
    "Jornal completa de trabajo - FTTH/Wireless",
    "Soporte FTTX",
    "Soporte con Corte / Reinstalación FTTX",
    "Relevamiento (previo a instalación)",
    "Soporte en garantía",
    "Cable Preco 50 mts",
    "Cable Preco 100 mts",
    "Cable Preco 150 mts",
    "Cable Preco 220 mts",
    "Cable Preco 300 mts",
    "Cable Drop MTS. Externo",
    "Retenedor FO y Gancho",
    "Cinta Metalica",
    "Pitón 6mm",
    "Ojal de Acero",
    "Canaleta",
    "Cintillo",
    "TTP",
    "Conectores RJ45",
    "Cable UTP",
    "Conectores SC",
    "Hebillas",
    "Grampas",
    "Tarugo c/ Tope p/ tornillo Hueco 6mm",
    "Tornillo",
    "Nomenclatura del NAP",
    "Serial ONT",
    "Cantidad de Decos",
    "Serial Flow",
    "Serial Flow",
    "Serial Flow",
    "Serial Flow",
    "Serial Flow",
    "Serial Ext",
    "Serial Ext",
    "Serial Ext",
    "Serial Ext",
    "Serial Equipo Configurado",
    "Serial Equipo Configurado",
    "Serial Equipo Configurado",
    "Control Flow",
    "ONT Retirado",
    "Flow Retirado",
    "Ext Retirado",
    "ROSETA",
    "Numero de Cuadrilla",
    "Adaptador Mecánico",
    "Convertidor HDMI a RCA",
    "Cuadrilla",
    "Usuario",
    "Instalación Básica 1P (Solo FTTX)",
    "Instalación Sólo Flow",
    "Instalación Básica 2P (FTTX + FLOW)",
    "Media Jornada de trabajo - FTTH/Wireless",
    "Jornal completa de trabajo - FTTH/Wireless",
    "Soporte FTTX",
    "Soporte con Corte / Reinstalación FTTX",
    "Relevamiento (previo a instalación)",
    "Soporte en garantía",
    "Total",
    "Comentarios",
    "Fecha realización"
]];

const cuadrilla = { "id": 4, "numero": "80CTD340 - ALVARO ROBLEDO" }

export const headingsTableGarantia = [[
    'FECHA 1RA OT',
    'CONTRATO 1RA OT',
    'NRO OT 1RA OT',
    'CLIENTE 1RA OT',
    'CUADRILLA 1RA OT',
    'COMENTARIOS 1RA OT',
    'FECHA 2DA OT',
    'CONTRATO 2DA OT',
    'NRO OT 2DA OT',
    'CLIENTE 2DA OT',
    'CUADRILLA 2DA OT',
    'COMENTARIOS 2DA OT',
    'DÍAS DIFERENCIA',
    'MONTO'
]]

export const motivos = [
    { id: 0, motivo: "Movil Roto", resumen: 'MR' },
    { id: 1, motivo: "Libre", resumen: 'L' },
    { id: 2, motivo: "Enfermedad", resumen: 'E' },
    { id: 3, motivo: "Suspensión", resumen: 'S' },
    { id: 4, motivo: "Ausente", resumen: 'A' },
    { id: 5, motivo: "Sin Tareas", resumen: 'ST' },
    { id: 6, motivo: "Permiso Especial", resumen: 'PE' },
    { id: 7, motivo: "Bloqueado", resumen: 'B' },
    { id: 8, motivo: "Personal Capacitación", resumen: 'PC' },
    { id: 9, motivo: "Otro", resumen: 'O' },
    { id: 10, motivo: "Domingo", resumen: 'D' },
    { id: 11, motivo: "Feriado", resumen: 'F' },
    { id: 12, motivo: "Trabajado", resumen: 'T' }
]
